export default ({request}) =>({
    masCustomerListApi(data = {}){
        return request({
            url: '/master/master/customer/list',
            method:'post',
            data,
        })
    },
    masCustomerSaveApi(data = {}){
        return request({
            url: '/master/master/customer/save',
            method:'post',
            data,
        })
    },
    masCustomerDetailApi(data = {}){
        return request({
            url: '/master/master/customer/detail',
            method:'post',
            data,
        })
    },
    masCustomerDelApi(data = {}) {
        return request({
          url: '/master/master/customer/del',
          method: 'post',
          data,
        })
    },
})